<template>
    <h2>Patient Form</h2>

    <div class="md-form-input">
        <label for="sexe">Gender:</label>
        <select v-model="store.patientGender" id="sexe" name="sexe">
            <option value="male">Male</option>
            <option value="female">Female</option>
        </select>
    </div>

    <div class="md-form-input">
        <label for="age">Age:</label>
        <input v-model="store.patientAge" type="number" id="age" name="age" min="0">
    </div>

    <div class="md-form-input">
        <label for="taille">Height (cm):</label>
        <input v-model="store.patientHeight" type="number" id="taille" name="taille" step="0.01">
    </div>

    <div class="md-form-input">
        <label for="poids">Weight (kg):</label>
        <input v-model="store.patientWeight" type="number" id="poids" name="poids" step="0.01">
    </div>

    <div class="md-form-input">
        <label for="calcul_surface">Automatic Body Surface Area (m²):</label>
        <input v-model="store.patientSurfaceArea" type="field" id="calcul_surface" name="calcul_surface" readonly>
    </div>

    <div class="md-form-input">
        <label for="créatinine">Creatinine (µmol/L):</label>
        <input v-model="store.patientCreatinine" type="field" id="créatinine" name="créatinine">
    </div>

    <div class="md-form-input">
        <label for="Cockroft">Cockcroft-Gault (mL/min):</label>
        <input v-model="store.patientCockroft" type="field" id="Cockroft" name="Cockroft" readonly>
    </div>

    <div class="md-form-input">
        <label for="MDRD">MDRD (mL/min/1.73m²):</label>
        <input v-model="store.patientMDRD" type="field" id="MDRD" name="MDRD" readonly>
    </div>

    <div class="md-form-input">
        <label for="MDRD_corr">MDRD adjusted for body surface area (mL/min):</label>
        <input v-model="store.patientMDRDCorr" type="field" id="MDRD_corr" name="MDRD_corr" readonly>
    </div>

    <div class="md-form-input">
        <label for="CKD_EPI">CKD-EPI (mL/min/1.73m²):</label>
        <input v-model="store.patientCKDEPI" type="field" id="CKD_EPI" name="CKD_EPI" readonly>
    </div>

    <div class="md-form-input">
        <label for="dialyse_continue">Continuous Dialysis:</label>
        <select v-model="store.patientDialysisContinue" id="dialyse_continue" name="dialyse_continue">
            <option value="yes">Yes</option>
            <option value="no">No</option>
        </select>
    </div>

    <div class="md-form-input">
        <label for="dialyse_intermittente">Intermittent Dialysis:</label>
        <select v-model="store.patientDialysisIntermittent" id="dialyse_intermittente" name="dialyse_intermittente">
            <option value="yes">Yes</option>
            <option value="no">No</option>
        </select>
    </div>

    <div class="md-form-input">
        <label for="localisation_infection">Infection Location:</label>
        <input v-model="store.patientInfectionLocation" type="text" id="localisation_infection" name="localisation_infection">
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useTestStore } from "@/stores/testStore";

const store = useTestStore();

// Watch for changes in patient data and recalculate metrics
watch(
  [() => store.patientAge, () => store.patientHeight, () => store.patientWeight, () => store.patientCreatinine, () => store.patientGender],
  () => {
    store.calculatePatientMetrics();
  },
  { immediate: true }
);

</script>

<style scoped>

.md-form-input {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0px 0px 10px 10px;
}



.md-form-input label {
    width: 300px;
    text-align: left;
}

</style>